import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Container, Title, Summary, Link } from './experiencesListItem.styles';
import { SUMMARY_SECONDARY_TYPE } from '../experienceSummary/experienceSummary.constants';
import { LazyLoadImage } from '../../../shared/components/lazyLoadImage';
import { renderWhenTrue } from '../../../shared/utils/rendering';
import { GTMEvents } from '../../../modules/analytics';

export const SIZES = ['100', '250', '400', '600', '800', '1000', '1200'];

export class ExperiencesListItem extends PureComponent {
  static propTypes = {
    experience: PropTypes.object,
    file: PropTypes.object,
    placeholder: PropTypes.bool,
    location: PropTypes.object.isRequired,
    logGTMEvent: PropTypes.func.isRequired,
    index: PropTypes.number,
  };

  handleClick = () => {
    if (!this.props.placeholder) {
      this.props.logGTMEvent(GTMEvents.ClickOnExperience, {
        experience: this.props.experience,
        position: this.props.index + 1,
        location: this.props.location,
      });
    }
  };

  renderInfo = renderWhenTrue(() => (
    <>
      <Title>{this.props.experience.name}</Title>
      <Summary experience={this.props.experience} type={SUMMARY_SECONDARY_TYPE} hideDiscountBorder />
    </>
  ));

  render() {
    const LinkComponent = this.props.placeholder ? Fragment : Link;
    const linkProps = this.props.placeholder ? {} : { experience: this.props.experience };

    return (
      <Container onClick={this.handleClick}>
        <LinkComponent {...linkProps}>
          <LazyLoadImage
            imgProps={{ sizes: '(max-width: 425px) 100vw, 33.3vw' }}
            sizes={SIZES}
            file={this.props.file}
            ratio={this.props.experience.ratio}
          />
          {this.renderInfo(!this.props.placeholder)}
        </LinkComponent>
      </Container>
    );
  }
}
